// extracted by mini-css-extract-plugin
export default {"pageWrap":"db-z","fullWidth":"eb-z","heading":"fb-z","fullBleed":"gb-z","hidden":"hb-z"};